import styled from "styled-components";

export const SearchInput = styled.input`
  width: 400px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
`;

export const PdfLink = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 0px;

  img {
    margin-right: 6px;
  }
`;